import { createContext } from 'react';
import type { useEntityFeatures } from '@/hooks/use-entity-features';

/** A disclosure boundary shares its existing feature observer with nested readers. */
export const EntityFeaturesContext = createContext<ReturnType<typeof useEntityFeatures> | null>(null);
